import { Component, Input } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { OemService } from 'src/app/services/oem/oem.service';
import { AllProductService } from 'src/app/services/shared/product-settings/all-products.service';
import { CategoryService } from 'src/app/services/shared/product-settings/category.service';

@Component({
  selector: 'app-products',
  templateUrl: './products.component.html',
  styleUrls: ['./products.component.scss']
})
export class ProductsComponent {
  @Input() data : any;
  @Input() id: string = '';
  type : string = '';
  showNoRecordsFounds: boolean = false;
  itemsPerPage =12;
  products: any[] = [];
  originalData: any[] = [];
  filterColumns: string[] = ['Products', 'Region', 'Application', 'Shape', 'Size', 'Model', 'SampleType', 'LightSource', 'Configuration', 'IntensityAt1ms', 'Options'];

  @Input() brandProfileProducts: any ='';
  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private oemService : OemService,
    private allProductService: AllProductService,private categoryService:CategoryService
) { }

  ngOnInit(): void {
    if(this.router.url.includes('type=distributor')) {
       if(!this.data.productCategoriesName || this.data.productCategoriesName.length == 0){
        this.showNoRecordsFounds = true
      } else if(this.data.productCategoriesName && this.data.productCategoriesName.length > 0) {
        this.showNoRecordsFounds = false
        this.products = this.data.productCategoriesName;
        this.originalData  = this.data.productCategoriesName;
        this.paginatedItems = this.products.slice(0, this.itemsPerPage);
      }
      this.type='distributor';
      this.checkScreenSize();
      return;
    }
    this.getAllProductsById(this.data.id);  
    this.type='brand';
  }

  size: number = 0;
  page: number = 0;

  getDistributorProducts(id: string): void {
    this.categoryService.getCategoriesByDistributorId(id).subscribe({
      next: (response) => {
        if(response.data.length == 0){
         this.showNoRecordsFounds = true
        } else {
         this.showNoRecordsFounds = false
         this.products = response.data;
         this.originalData  = response.data;
         this.paginatedItems = this.products.slice(0, this.itemsPerPage);
        }
       },
       error: (error) => {
       }
    })
  }

  getAllProductsById(brandId: string) {
    this.allProductService.getAllProductsByOemId(brandId).subscribe({
      next: (response) => {
       if(response.data.length == 0){
        this.showNoRecordsFounds = true
       } else {
        this.showNoRecordsFounds = false
        this.products = response.data;
        this.originalData  =response.data;
        this.paginatedItems = this.products.slice(0, this.itemsPerPage);
       }
      },
      error: (error) => {
      }
    });
  }

  paginatedItems: {
    id: string;
    oemId: string;
    specifications: { name: string; value: string; fromValue?: string|undefined; fromUnit?: string|undefined; }[];
    images: string[],
    logo: string, name: string, oemName: string, description: string, tags: string[],image: string;
  }[] = [];

  onPageChanged(paginatedData: any[]): void {
    this.paginatedItems = paginatedData;
  }

  filteredData = this.products;

  onFilteredData(filtered: any[]): void {
    this.filteredData = filtered;
    this.products = filtered;
    this.paginatedItems = this.filteredData.slice(0, this.itemsPerPage);
    if(this.paginatedItems.length == 0){
      this.showNoRecordsFounds = true
    } else {
      this.showNoRecordsFounds = false
    }
  }

  onViewDetails(product: any) {
    this.router.navigateByUrl(`/product-details/${product.id}`);
  }
  sanitizeUrl(url: string): void {
    if (!url) {
      return;
    }
    if (!url.startsWith('http://') && !url.startsWith('https://')) {
      url = 'https://' + url;
    }
    window.open(url, '_blank', 'noopener,noreferrer');
  }
  setPageFromQuery(pageNumber: number) {
    const startIndex = (pageNumber-1 ) * this.itemsPerPage;
    const endIndex = startIndex + this.itemsPerPage;
    this.paginatedItems = this.products.slice(startIndex, endIndex);
  }
  checkScreenSize() {
    const resizeWidth = window.innerWidth;
    if(this.type === 'distributor'){
      if (resizeWidth > 1560 && resizeWidth < 1950) {
        this.itemsPerPage = 15;
      }
      else if (resizeWidth >= 1350 && resizeWidth < 1559) {
        this.itemsPerPage = 12;
      }
      else if (resizeWidth < 1350) {
        this.itemsPerPage = 9;
      } else {
        this.itemsPerPage = 10;
      }
    }
  }
}
